import { Box, ListItem, Typography } from '@mui/material';
import moment from 'moment';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { EmployeeItemInfo } from '~/components/GenericList/EmployeeItemInfo';
import { WorkflowProposalStatus } from '~/components/WorkflowProposalStatus';
import { ProposalProps, getProposalTypeTranslationKey } from '~/data/proposals';
import { isSameTime } from '~/utils/helpers/date';

import { useSxStyles } from './useStyles';

type PropsType = {
  proposal?: ProposalProps;
};
export const EmployeeProposalStatus = (props: PropsType) => {
  const { proposal } = props;
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  const formatTimestamp = (date?: Date) =>
    !!date ? moment(date).format('L LT') : '';

  const isUpdated =
    !!proposal?.createdTime &&
    !!proposal?.updatedTime &&
    !isSameTime(proposal?.createdTime, proposal?.updatedTime);

  const StatusValue = (props: { label: ReactNode; children: ReactNode }) => {
    const { label, children } = props;
    return (
      <Box>
        <Typography component={'div'} variant={'caption'} color={'grey'}>
          {label}
        </Typography>
        <Box sx={sxStyles.statusValue}>{children}</Box>
      </Box>
    );
  };

  return (
    <Box sx={sxStyles.root}>
      <Box className={'target'}>
        <ListItem>
          <EmployeeItemInfo employeeId={proposal?.targetId} />
        </ListItem>
      </Box>
      <Box sx={sxStyles.stats}>
        <Box className={'type'}>
          <StatusValue label={t('type')}>
            {!!proposal?.proposalType &&
              t(getProposalTypeTranslationKey(proposal.proposalType))}
          </StatusValue>
        </Box>
        <Box className={'status'}>
          <StatusValue label={t('status')}>
            {!!proposal?.proposalStatus && (
              <WorkflowProposalStatus status={proposal.proposalStatus} />
            )}
          </StatusValue>
        </Box>
        <Box className={'created'}>
          <StatusValue label={t('laCreated')}>
            {formatTimestamp(proposal?.createdTime)}
          </StatusValue>
        </Box>
        {isUpdated && (
          <Box className={'updated'}>
            <StatusValue label={t('laUpdated')}>
              {formatTimestamp(proposal?.updatedTime)}
            </StatusValue>
          </Box>
        )}
      </Box>
    </Box>
  );
};
